import { Palette } from '@infoods/lifebase-ui';
import { Plugin } from 'chart.js';

import { drawPoint, getChartBorder } from '../../../../../shared/features/charts';

export const getGraphPlugins = (palette: Palette): Plugin[] => [
  getChartBorder(palette),
  {
    id: 'hover',
    beforeTooltipDraw(chart, args) {
      const { ctx } = chart;
      const { tooltip } = args;

      if (!tooltip.dataPoints || tooltip.dataPoints.length === 0) {
        return;
      }

      const dataIndex = tooltip.dataPoints[0].dataIndex;
      const pointX = tooltip.caretX;

      const pointY = chart.getDatasetMeta(0).data[dataIndex]?.y;

      if (pointY) {
        drawPoint(ctx, { pointX, pointY, strokeColor: palette.info[500] }, palette);
      }
    },
  },
];
